// O toast do painel atual (app.js:16), com o mesmo desenho e os mesmos 2,6 s.
//
// Vira contexto porque quem avisa "copiado" ou "nota publicada" está no fundo
// da árvore, e passar a função de mão em mão por dez componentes é o tipo de
// encanamento que se abandona no meio e deixa metade das ações silenciosas.
import { createContext, useCallback, useContext, useEffect, useRef, useState, type ReactNode } from 'react';

const Contexto = createContext<(msg: string) => void>(() => { /* fora do provedor não há onde mostrar */ });

export const useRecado = () => useContext(Contexto);

export function ProvedorDeRecado({ children }: { children: ReactNode }) {
  const [msg, setMsg] = useState('');
  const [aparecendo, setAparecendo] = useState(false);
  const relogio = useRef<number | null>(null);

  const avisar = useCallback((texto: string) => {
    setMsg(texto);
    setAparecendo(true);
    if (relogio.current) window.clearTimeout(relogio.current);
    relogio.current = window.setTimeout(() => setAparecendo(false), 2600);
  }, []);

  useEffect(() => () => { if (relogio.current) window.clearTimeout(relogio.current); }, []);

  return (
    <Contexto.Provider value={avisar}>
      {children}
      <div className={`toast${aparecendo ? ' show' : ''}`} role="status" aria-live="polite">{msg}</div>
    </Contexto.Provider>
  );
}

/**
 * `navigator.clipboard` não existe fora de contexto seguro (http por IP) nem
 * sem gesto do usuário — e são justamente estes botões que levam o dev para o
 * CLI. O caminho antigo do `execCommand` fica como rede, igual a app.js:77-88.
 */
export async function copiar(texto: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(texto);
    return true;
  } catch { /* segue para o caminho antigo */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = texto;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, texto.length);
    const ok = document.execCommand('copy');
    ta.remove();
    return ok;
  } catch {
    return false;
  }
}
